<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Perquisite
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-auto">
                <label class="Label">From Month</label>
                <ngb-datepicker #dp [(ngModel)]="FromMonth" class="month-year" (navigate)="onNavigate($event)"
                    name="dateselect" style="width: 100%;"></ngb-datepicker>
            </div>
            <div class="col-auto">
                <label class="Label">To Month</label>
                <ngb-datepicker #dp1 [(ngModel)]="ToMonth" class="month-year" (navigate)="onNavigate2($event)"
                    name="dateselect2" style="width: 100%;"></ngb-datepicker>
            </div>
            <div class="col-auto mt-4">
                <button type="button" (click)="PerquisiteTransactionDetailsLoad('PT')" class="btn btn-primary btn-sm" [disabled]="isDisabled">
                    <i class="bi bi-search me-1" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
            </div>
        </div>
        <div class="mt-2">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <!-- <th scope="col" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Edit</th> -->
                        <th scope="col">Edit</th>
                        <th scope="col">Emp Detail</th>
                        <th scope="col">EmpType</th>
                        <th scope="col">MonthYear</th>
                        <th scope="col">Perquisite Name</th>
                        <th scope="col">Sub PayHead Name</th>
                        <th scope="col">Gross Value</th>
                        <th scope="col">Employee Recovery</th>
                        <!-- <th scope="col">Approved Amount</th> -->
                        <th scope="col">Taxable Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of PerquisiteData; let i = index">
                        <!-- <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit}" class="text-center align-content-center">
                        <button class="btn btn-sm btn-warning" type="button"><i
                                class="bi bi-pencil-square"></i></button>
                    </td> -->
                        <td class="text-center align-content-center">
                            <button (click)="onEditClick(site)" class="btn btn-sm btn-outline-warning" type="button"><i
                                    class="bi bi-pencil-square"></i></button>
                        </td>
                        <td>
                            <div class="row no-gutters cursor-pointer" style="align-items: center;width: 270px;">
                                <div class="col userdetail">
                                    <span class="text-label">{{site['FullName']}}</span><br />
                                    <span class="text-label-light">#{{site['EmpCode']}}</span><br />
                                </div>
                            </div>
                        </td>
                        <td>{{ site['EmpType'] }}</td>
                        <td>{{ site['MonthYear'] }}</td>
                        <td>{{ site['Perquisite_Name'] }}</td>
                        <td>{{ site['Sub_PayHead_Name'] }}</td>
                        <td>{{ site['Gross_Value'] }}</td>
                        <td>{{ site['Employee_Recovery'] }}</td>
                        <!-- <td>{{ site['Approved_Amount'] }}</td> -->
                        <td>{{ site['Taxable_Amount'] }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" (click)="upload()" class="btn btn-primary btn-sm" [disabled]="isDisabled">
                    <i class="bi bi-upload me-1" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Upload':'Loading...'}}
                </button>
            </div>
            <div class="col-auto">
                <button type="button" (click)="PerquisiteTransactionDetailsLoad('PM');" class="btn btn-primary btn-sm"
                    [disabled]="isDisabled">
                    <i class="bi bi-download me-1" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Perquisite Master':'Loading...'}}
                </button>
            </div>
            <div class="col-auto">
                <button type="button" (click)="excelDownload()" class="btn btn-primary btn-sm" [disabled]="isDisabled">
                    <i class="bi bi-download me-1" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>